import { useActionState, useContext, useEffect, useOptimistic, useRef, useState } from "react";
import axios from "axios";

import AppContext from "../contexts/AppContext";
import CookieContext from "../contexts/CookieContext";

const Iine = () => {
  const { cookies } = useContext(CookieContext);
  const { apiHost, AppButton } = useContext(AppContext);
  const basePath = 'checklist/';

  const [error, setError] = useState();
  const inputRef = useRef(null);
  const [checklists, setChecklists] = useState([]);
  const [nowOnUpdates, setNowOnUpdates] = useState([
    { id: 0, nowOnUpdate: false },
    { id: 1, nowOnUpdate: false },
    { id: 2, nowOnUpdate: false },
    { id: 3, nowOnUpdate: false },
    { id: 4, nowOnUpdate: false },
    { id: 5, nowOnUpdate: false },
    { id: 6, nowOnUpdate: false },
    { id: 7, nowOnUpdate: false },
    { id: 8, nowOnUpdate: false },
    { id: 9, nowOnUpdate: false },
    { id: 10, nowOnUpdate: false },
    { id: 11, nowOnUpdate: false },
    { id: 12, nowOnUpdate: false },
    { id: 13, nowOnUpdate: false },
    { id: 14, nowOnUpdate: false },
    { id: 15, nowOnUpdate: false },
    { id: 16, nowOnUpdate: false },
    { id: 17, nowOnUpdate: false },
    { id: 18, nowOnUpdate: false },
    { id: 19, nowOnUpdate: false },
    { id: 20, nowOnUpdate: false },
    { id: 21, nowOnUpdate: false },
    { id: 22, nowOnUpdate: false },
    { id: 23, nowOnUpdate: false },
    { id: 24, nowOnUpdate: false },
    { id: 25, nowOnUpdate: false },
    { id: 26, nowOnUpdate: false },
    { id: 27, nowOnUpdate: false },
    { id: 28, nowOnUpdate: false },
    { id: 29, nowOnUpdate: false },
    { id: 30, nowOnUpdate: false },
    { id: 31, nowOnUpdate: false },
    { id: 32, nowOnUpdate: false },
    { id: 33, nowOnUpdate: false },
    { id: 34, nowOnUpdate: false },
    { id: 35, nowOnUpdate: false },
    { id: 36, nowOnUpdate: false },
    { id: 37, nowOnUpdate: false },
    { id: 38, nowOnUpdate: false },
    { id: 39, nowOnUpdate: false },
    { id: 40, nowOnUpdate: false },
    { id: 41, nowOnUpdate: false },
    { id: 42, nowOnUpdate: false },
    { id: 43, nowOnUpdate: false },
  ]);
  const [queue, setQueue] = useState([]);

  const fetchChecklists = async (param) => {

    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setChecklists(data);
        // setNowOnUpdates(checklists.map(checklist => {
        //   if (checklist.id)
        //   return ([{...nowOnUpdates, isPending: true}])
        // }))
      //   checklists.map((checklist, index) => {
      //     setNowOnUpdates({...nowOnUpdates, nowOnUpdate: true})
      // })


      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
    } catch (err) {
      console.log(err);
      setError('通信エラー');
    } finally {
    }
  }

  const [updatedPost, submitAction, isPending] = useActionState(
    async (previousPost, formData) => {
      const message = formData.get('message');

      const optimistic = {...previousPost,
        // liked: !previousPost.liked,
        // is_checked: !is_checked,
      };
      // alert(message)
      updateOptimisticPost(optimistic);

      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          // const updatedPost = await axios.put(`${apiHost}${basePath}check/${postId}/`, 
          const response = await axios.post(`${apiHost}${basePath}`, 
              {
              // name: formData.get('checklistName'),
              name: inputRef.current.value,
            },
            {headers},
          )

          if (response.status === 201) {
            // 更新した名前を返す
            return response.data
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        // console.log(err);
        // setError('通信エラー');
        return previousPost;
      } finally {
      }
    }, ""
  );
 
  const [updatedPost2, submitAction2, isPending2] = useActionState(
    async (previousPost, formData) => {
      const postId = Number(formData.get('postId'));
      // const liked = formData.get('liked') === 'true';
      const postIsChecked = formData.get('postIsChecked');
      const postName = formData.get('postName');
      // alert(is_checked)
      // alert(postIsChecked)

      // const optimistic2 = {...previousPost,
      //   // liked: !previousPost.liked,
      //   is_checked: !is_checked,
      // };
      const optimistic2 = {
          "id": postId,
          "name": postName + '（更新中）',
          "is_checked": !postIsChecked,
          // "checked_datetime": null,
          // "created_at": "2025-01-01T09:00:00+09:00",
          // "updated_at": "2026-04-01T22:08:02.577492+09:00",
          // "ip_addr": "127.0.0.1",
          // "device_uuid": "00000000-0000-0000-0000-000000000000"
      }

      setQueue([...queue, formData.get('postName')])
      updateOptimisticPost2(optimistic2);

      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `JWT ${cookies.jwtAccess}`,
          }

          // const updatedPost = await axios.put(`${apiHost}${basePath}check/${postId}/`, 
          const response = await axios.post(`${apiHost}${basePath}check/${postId}/`, 
          // const response = axios.post(`${apiHost}${basePath}check/${postId}/`, 
              {
              // name: formData.get('checklistName'),
              name: inputRef.current.value,
            },
            {headers},
          )

          if (response.status === 200) {
            // 更新した名前を返す
            return response.data
          } else if (response.status === 401) {
            setError('ログインしてください');
          } else {
            setError('エラー');
          }
        } else {
          setError('認証エラー');
        }
      } catch (err) {
        // console.log(err);
        // setError('通信エラー');
        return previousPost;
      } finally {
      }
    }, ""
  );
  // https://www.youtube.com/watch?v=LxrXKjZJPjk
  const [optimisticPost, updateOptimisticPost] = useOptimistic(updatedPost);
  const [optimisticPost2, updateOptimisticPost2] = useOptimistic(updatedPost2);

  // load時
  useEffect(() => {
    fetchChecklists();
  }, [optimisticPost, optimisticPost2, queue]);
  
  return (
    <>
      {/* {nowOnUpdates.map((nowOnUpdate, index) => (
        <li className="contents_li" key={nowOnUpdate.id}>
          {nowOnUpdate.id}:{nowOnUpdate.nowOnUpdate}
        </li>
      ))} */}
      <p>queue:{queue}</p>
      <p>{optimisticPost2.postId}</p>
      <p>{optimisticPost2.name}</p>
      <p>{optimisticPost2.is_checked == true ? 'true' : 'false'}</p>
      <p>{optimisticPost2.checked_datetime}</p>
      {/* <div key={optimisticPost.id}> */}
      {/* <div key='1'> */}
      <div>
        <form action={submitAction}>
          <input style={{ margin: "5px", fontSize: 30, }} type="text" name="message" placeholder="メッセージを入力" ref={inputRef} />

          <AppButton type="submit" style={{ margin: "5px", fontSize: 30}} disabled={isPending}>送信</AppButton>
          {/* 送信中の表示 */}
          {isPending && <>送信中...</>}
          {/* 更新完了時の表示 */}
          {!isPending && 'ooooo'}
        </form>
      </div>

      <div className="contents">
        <ul className="contents_ul">
          {checklists.map((checklist, index) => (
            <li className="contents_li" key={checklist.id}>
              <form action={submitAction2}>
                <input type="hidden" name="postId" value={checklist.id} />
                <input type="hidden" name="postIsChecked" value={checklist.is_checked} />
                <input type="hidden" name="postName" value={checklist.name} />
                {checklist.checked_datetime}
                <button type="submit">
                  {/* {setNowOnUpdates([...nowOnUpdates, { id: checklist.id, nowOnUpdate: false }])} */}
                  {checklist.is_checked ? '完了' : '未完了'}
                </button>
                ★{index}★
                [{checklist.id}]
                {checklist.name}
                {isPending2 && <>更新してるよ</>}
                {/* iiiidddd:{nowOnUpdates[index].id} */}
                iiiidddd:{nowOnUpdates[index].nowOnUpdate == true ? '真' : '偽'}
                {/* nowOnUpdates:{nowOnUpdates[index].nowOnUpdate} */}
              </form>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
export default Iine